<template>
  <div class="wrapper">
    <section class="wmdcp">
      <div class="title-box">
        <h2 class="title">我们的产品</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="left">
          <div class="item clearfix">
            <div class="logo">
              <img src="../assets/img/img-logo-ctb.png" alt="五级钻石纠错本">
            </div>
            <div class="msg">
              <p class="name">五级钻石纠错本</p>
              <p class="text">根据知识认知规律，科学设计五级纠错，个性化呈现。由知心慧学“个性化学习宝”系统智能整理，学管团队打印制作成精美活页夹。</p>
            </div>
          </div>
          <div class="item clearfix">
            <div class="logo">
              <img src="../assets/img/img-logo-tfb-2.png" alt="两步皇冠个性化学习宝">
            </div>
            <div class="msg">
              <p class="name">两步皇冠个性化学习宝</p>
              <p class="text">知心慧学“个性化学习宝”系统针对学生自己的错题情况，量身定制个性化训练方案，查缺补漏，举一反三，避免学生盲目训练，减轻负担，提高学习效率。打印制作成精美活页夹。</p>
            </div>
          </div>
          <div class="item clearfix">
            <div class="logo">
              <img src="../assets/img/img-logo-tfb-3.png" alt="三步尽管个性化学习宝">
            </div>
            <div class="msg">
              <p class="name">三步金冠个性化学习宝</p>
              <p class="text">
                知心慧学“个性化学习宝”系统针对学生自己的错题情况，量身定制个性化训练方案，查缺补漏，举一反三。避免学生盲目训练，减轻负担，提高学习效率。错题、变式训练题同时呈现，方便纠错学习，体验感更好。打印制作成精美活页夹。</p>
            </div>
          </div>
        </div>
        <div class="right">
          <img class="img-wmdcp" src="../assets/img/img-wmdcp.png" alt="">
        </div>
      </div>
    </section>
    <div class="jctf">
      <img class="img-jctf" src="../assets/img/img-jctf.png" alt="">
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>
<style scoped lang="less">

  @highlight-border: #3ECDBAFF;
  @highlight-background: #50d2c2;

  .title-box {
    .title {
      line-height: 56px;
      font-size: 40px;
      text-align: center;
      color: #333;
    }
    .border-bottom {
      display: block;
      margin: 0 auto;
      padding-top: 16px;
      width: 40px;
      border-bottom: 4px solid @highlight-border;
    }
  }

  .wmdcp {
    padding-top: 80px;
    .content {
      width: 1180px;
      margin: 0 auto;
      padding-top: 80px;
      font-size: 0;
      .left {
        display: inline-block;
        width: 600px;
        .item {
          margin-bottom: 40px;
          &:last-child {
            margin-bottom: 0;
          }
          .logo {
            display: inline-block;
            vertical-align: middle;
            width: 54px;
            height: 90px;
            line-height: 90px;
            /*text-align: center;*/
            img {
              margin-top: 22px;
              /*border: 1px dashed #888;*/
              vertical-align: middle;
            }
          }
          .msg {
            display: inline-block;
            vertical-align: middle;
            width: 500px;
            margin-left: 42px;
            .name {
              line-height: 28px;
              font-size: 20px;
              color: #50D2C2;
              font-weight: 500;
            }
            .text {
              margin-top: 10px;
              font-size: 16px;
              line-height: 30px;
              color: #666;
            }
          }
        }

      }
      .right {
        display: inline-block;
        width: 480px;
        height: 480px;
        margin-left: 100px;
        /*border: 1px dashed #888;*/
        box-sizing: border-box;
      }

    }
  }

  .jctf {
    width: 1180px;
    margin: 0 auto;
    /*border: 1px dashed #888;*/
    margin-top: 120px;
    margin-bottom: 80px;
    .img-jctf {
      padding-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// Parent.vue?c768f88e